// Configuration API
const API_BASE_URL = import.meta.env.VITE_REACT_APP_API_EP_URI;

export interface ProjectGroupMember {
  user_id: number;
  lastname: string;
  firstname: string;
  email: string;
}

export interface AdminProjectGroup {
  id: number;
  generic_name: string;
  td_group: string;
  id_group: number;
  name: string | null;
  lock_expires_at: string | null;
  pending_candidate: { user_id: number; lastname: string; firstname: string } | null;
  members: ProjectGroupMember[];
}

interface ActionResponse {
  message: string;
  [key: string]: any;
}

async function callApi(path: string, method: 'GET' | 'POST' | 'DELETE', accessToken: string, body?: any): Promise<any> {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  const json = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(json.message || `HTTP error! status: ${response.status}`);
  }

  return json;
}

class ProjectGroupAdminService {

  async list(accessToken: string): Promise<AdminProjectGroup[]> {
    return callApi('/project-groups', 'GET', accessToken);
  }

  // Si l'étudiant·e est déjà dans un autre groupe, il/elle en est déplacé·e (un seul appel).
  async addMember(groupId: number, userId: number, accessToken: string): Promise<ActionResponse> {
    return callApi(`/admin/project-groups/${groupId}/members`, 'POST', accessToken, { user_id: userId });
  }

  async removeMember(groupId: number, userId: number, accessToken: string): Promise<ActionResponse> {
    return callApi(`/admin/project-groups/${groupId}/members/${userId}`, 'DELETE', accessToken);
  }
}

export const projectGroupAdminService = new ProjectGroupAdminService();
